import { Tab } from '@chakra-ui/react';

import {
    customTabStylesCombineTheme,
    selectedTabStylesCombineTheme,
} from '@/constants';

/**
 * @typedef {{tab: string}} CustomTabProps - {tab:string}
 * @param {import('@chakra-ui/react').TabProps & CustomTabProps} props
 * */
function TabHeader({ tab, ...props }) {
    return (
        <Tab
            w="full"
            _selected={selectedTabStylesCombineTheme}
            sx={customTabStylesCombineTheme}
            transition="all 0.2s ease"
            {...props}>
            {tab}
        </Tab>
    );
}

export { TabHeader };
